import React from "react";
import { TextField, Typography } from "@material-ui/core";
import { useLiveTextValue } from "../modules/liveTextValue";

/**
 *
 * @param props
 * @param props.value
 * @param props.classes
 * @param props.setValue
 * @returns {JSX.Element}
 */
export default function editorCaption(props) {
  const { text, onChange, onFocus, onBlur } = useLiveTextValue({
    value: props.value,
    setValue: props.setValue,
    livePreview: props.livePreview
  });
  function gettingMargin(numberMargin) {
    if (props.tooltip != undefined) {
      if (numberMargin) {
        return numberMargin.toString() + "px";
      }
    } else return (0).toString() + "px";
  }
  return (
    <>
      {" "}
      {props.isVisible && (
        <div className={props.classes.editorItem}>
          <Typography
            style={{ marginTop: gettingMargin(props.tooltipLength), fontSize: "0.75em" }}
            id="discrete-slider"
            gutterBottom
          >
            {_.get(props, "label")}
          </Typography>
          <TextField
            onKeyDown={(event) => {
              event.stopPropagation();
            }}
            id={`${props.id}.textField`}
            className={props.classes.textField}
            // label={_.get(props, `label`)}
            value={text}
            multiline={props.multiline ? true : false}
            rows={props.rows ? props.rows : 1}
            rowsMax={props.rowsMax ? props.rowsMax : 1}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={(event) => {
              if (props.userPermissions["editContent"] === false) {
                props.createSnackbar(
                  "You do not have permission to update, contact your administrator.",
                  "warning",
                  false
                );
                return;
              }
              onChange(event.target.value);
            }}
          ></TextField>
        </div>
      )}
    </>
  );
}
